import { memo, useCallback } from 'react'
import { Button } from '@mui/material'
import { MinusIcon, PlusIcon } from '@/assets'
import { styles } from './Counter.style'
import { Box } from '@/components/Layout'
import { Text } from '@/components/Data'

interface CounterProps {
  /**
   * The min value of the counter.
   */
  min?: number

  /**
   * maximum value of the counter.
   */
  max?: number

  /**
   * current value of the counter.
   */
  value: number

  /**
   * callback fired when counter value changes.
   */
  onChange?: (value: number) => void
}

const Counter = ({
  value,
  onChange,
  min = Number.NEGATIVE_INFINITY,
  max = Number.POSITIVE_INFINITY,
}: CounterProps) => {
  const increment = useCallback(() => {
    if (value < max) onChange?.(value + 1)
  }, [max, onChange, value])

  const decrement = useCallback(() => {
    if (value > min) onChange?.(value - 1)
  }, [min, onChange, value])

  return (
    <Box sx={styles.counterWrapper}>
      <Button
        variant="text"
        color="primary"
        onClick={decrement}
        sx={styles.button}
        disabled={value === min}>
        <MinusIcon />
      </Button>

      <Text sx={styles.count}>{value}</Text>

      <Button
        variant="text"
        color="primary"
        onClick={increment}
        sx={styles.button}
        disabled={value === max}>
        <PlusIcon />
      </Button>
    </Box>
  )
}

export default memo(Counter)
